import { colors } from "theme/palette";

import Text from "components/Text";

import { ETransactionColumnName } from "pages/Deal/FinancingEvents/FinancingEventCollapse/constants";

const ColumnRows = () => (
  <>
    {Object.values(ETransactionColumnName).map((value, index, arr) => (
      <Text
        color={colors.gray60}
        key={value}
        sx={{
          gridColumn:
            index === arr.length
              ? `${arr.length - 2} / -2`
              : `${index + 2} / ${index + 3}`,
        }}
      >
        {value}
      </Text>
    ))}
  </>
);

export default ColumnRows;
